// Copyright (c) 2026 Vigeos SASU. Tous droits réservés.
import React, { useEffect, useState } from 'react';
import {
  Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle,
  TextField, Typography,
} from '@mui/material';

/**
 * Confirmation d'un geste irréversible (clôture, effacement) par la saisie du
 * nom de l'établissement : sur une fiche qui en liste plusieurs, un simple
 * « Êtes-vous sûr ? » se valide par réflexe et finit par viser le mauvais.
 * `requiredWord` s'ajoute au nom quand il est donné (l'effacement exige aussi le
 * mot EFFACER, contrôlé par le backend).
 */
export default function NamedConfirmation({
  ouvert: isOpen, titre, nomEtablissement: facilityName, motExige: requiredWord = null, avertissement: warning, enCours = false,
  erreur: error = '', libelleBouton: buttonLabel, onAnnuler: onCancel, onConfirmer,
}) {
  const [label, setName] = useState('');
  const [mot, setMot] = useState('');

  useEffect(() => { if (isOpen) { setName(''); setMot(''); } }, [isOpen]);

  const nameOk = label.trim() === String(facilityName || '').trim() && label.trim() !== '';
  const motOk = !requiredWord || mot.trim() === requiredWord;

  return (
    <Dialog open={!!isOpen} onClose={() => !enCours && onCancel()} maxWidth="sm" fullWidth>
      <DialogTitle>{titre}</DialogTitle>
      <DialogContent dividers>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Alert severity="warning" sx={{ mb: 2 }}>{warning}</Alert>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Pour confirmer, tapez le nom de l&apos;établissement : <strong>{facilityName}</strong>
        </Typography>
        <TextField fullWidth size="small" autoComplete="off" label="Nom de l'établissement"
          value={label} onChange={(e) => setName(e.target.value)} disabled={enCours} sx={{ mb: 2 }} />
        {requiredWord && (
          <>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Puis tapez <strong>{requiredWord}</strong> en capitales.
            </Typography>
            <TextField fullWidth size="small" autoComplete="off" label="Mot de confirmation"
              value={mot} onChange={(e) => setMot(e.target.value)} disabled={enCours} />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={enCours}>Annuler</Button>
        <Button variant="contained" color="error" disabled={enCours || !nameOk || !motOk}
          onClick={() => onConfirmer({ confirm: requiredWord ? mot.trim() : undefined })}>
          {enCours ? <CircularProgress size={18} /> : buttonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
